/**
 * AppICEMAP — Basemap tiles
 * Shared tile templates so the main map and the small maps embedded elsewhere
 * (report gallery, previews) always draw the same basemap.
 */

/** @type {string} OpenStreetMap standard tiles */
export const TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

/** @type {string} CartoDB dark tiles — the app is dark-only */
export const TILE_URL_DARK =
	"https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png";

/** @type {string} Attribution required by both providers */
export const TILE_ATTRIBUTION =
	'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
